module.exports = {
    "page.asc.feedback.emailHolder": "--",
    "page.asc.feedback.descHolder": "කරුණාකර අපට වැඩි විස්තර බෙදා ගන්න.",
    "page.lu.feedback.subtitle": "ඔබගේ ප්‍රතිචාරය ලබා දීමට කාලය ගත කළාට ස්තූතියි. \nඅපි ඔබගේ ප්‍රතිචාරය භාවිතා කරමින් Lazada අත්දැකීම සියල්ලන්ට වඩා හොඳ කරනු ඇත.",
    "page.asc.onboarding.feedback.subtitle": "Lazada වෙත සාදරයෙන් පිළිගනිමු, අපි ඔබට උදව් කිරීමට මෙහි සිටිමු. \nකරුණාකර ඔබගේ ගිණුමට ලොග් වීමේදී හෝ ලියාපදිංචි වීමේදී ඇති ගැටළු අපට කියා දීමට මෙම ආකාරය පුරවන්න. \nඑසේම, ඔබට කිසිදු යෝජනා හෝ අදහස් ඇත්නම්, ඒවා ලියන්න නිදහස් වන්න.",
    "page.asc.feedback.title": "ප්‍රතිචාර ආකෘතිය",
    "page.asc.feedback.phoneHolder": "--",
    "page.common.needhelp": "ආධාරය අවශ්‍යද"
};